import icons from './icons'

const { stateful: statefulIcons } = icons

const dataFreshness = {
  responses: {
    error: () => ({
      ...statefulIcons.error,
      datetime: null,
      subtext: null,
      text: 'Error fetching data refresh date',
    }),
    loading: () => ({
      ...statefulIcons.loading,
      datetime: null,
      subtext: null,
      text: 'Loading ...',
    }),
    pending: () => ({
      ...statefulIcons.loading,
      datetime: null,
      subtext: null,
      text: 'Pending ...',
    }),
    recovering: () => ({
      ...statefulIcons.recovering,
      datetime: null,
      subtext: 'Page data may be out of date',
      text: 'Data recovery is in progress',
    }),
    refreshing: () => ({
      ...statefulIcons.refreshing,
      datetime: null,
      subtext: 'Page load may be delayed',
      text: 'Data is refreshing',
    }),
    stale: (dataRefreshedTime) => ({
      ...statefulIcons.error,
      datetime: dataRefreshedTime,
      subtext: null,
      text: 'Data needs refresh',
    }),
    success: (dataRefreshedTime) => ({
      ...statefulIcons.success,
      datetime: dataRefreshedTime,
      subtext: null,
      text: 'Data refreshed',
    }),
    unknown: (dataRefreshedTime) => ({
      ...statefulIcons.error,
      datetime: dataRefreshedTime,
      subtext: null,
      text: 'Data freshness is unknown',
    }),
  },
}

export default dataFreshness
